/**
 * 004 — Copy de sistema 🏛 + catálogos. La pareja NO escribe esto.
 * Fuente: specs/004-invitation-theming/diccionario-de-datos.md.
 * Incluye: rótulos de sección, prellenados ✍️ (usados cuando el campo viene vacío),
 * notas por tipo de evento, notas de niños/fotos, catálogo de itinerario y de vestimenta.
 * Español neutro LATAM (constitución §8).
 */

/** Rótulos de sección (🏛). */
export const ROTULOS = {
  sobreEyebrow: 'Nuestra boda',
  sobreCta: 'Ingresar',
  portadaFrase: 'Tenemos el honor de invitarte a nuestra boda',
  historia: 'Nuestra historia',
  reservaFecha: 'Reserva la fecha',
  reservaCta: 'Agendar en mi calendario',
  bendicion: 'Con la bendición de',
  eventos: 'Acompáñanos',
  eventoAccion: 'Ver ubicación',
  itinerario: 'Itinerario',
  vestimenta: 'Vestimenta',
  galeria: 'Nosotros',
  regalos: 'Mesa de regalos',
  confirmacion: 'Confirma tu asistencia',
} as const;

/** Prellenados ✍️: se usan cuando el campo llega vacío (campo vacío ≠ apagar). */
export const PRELLENADOS = {
  historiaTexto:
    'Con la bendición de Dios y de nuestros padres, hemos decidido unir nuestras vidas. Nos hará inmensamente felices contar contigo en el día más importante de nuestra historia.',
  historiaFrase:
    'Doce años, tres ciudades y un perro después, elegimos seguir eligiéndonos.',
  regalosMensaje:
    'Tu presencia es nuestro mejor regalo. Si además deseas obsequiarnos algo, te dejamos estas opciones.',
} as const;

/** Nota por tipo de evento (🏛 prellenado). */
export const NOTA_EVENTO: Record<'religiosa' | 'civil' | 'recepcion', string> = {
  religiosa: 'Se ruega puntualidad',
  // Sin nota por defecto: la invitación no debe afirmar restricciones/servicios
  // que la pareja no configuró explícitamente (campo vacío ⇒ no se muestra nota).
  civil: '',
  recepcion: '',
};

/** Título e icono por tipo de evento (🏛). */
export const EVENTO_META: Record<'religiosa' | 'civil' | 'recepcion', { titulo: string; icon: string }> = {
  religiosa: { titulo: 'Ceremonia religiosa', icon: 'church' },
  civil: { titulo: 'Ceremonia civil', icon: 'building-2' },
  recepcion: { titulo: 'Recepción', icon: 'utensils' },
};

/** Notas de niños (🏛), según el interruptor. */
export const NOTA_NINOS = {
  permitidos:
    'Los niños son bienvenidos — Tus pequeños también están invitados a celebrar con nosotros.',
  soloAdultos:
    'Sin niños — Amamos a tus pequeños, pero hemos decidido que esta celebración sea únicamente para adultos.',
} as const;

export const NOTA_FOTOS =
  'Comparte tus fotos — Sube tus fotografías del día a nuestro álbum compartido.';

/** Catálogo de itinerario (🏛): la pareja elige el momento; el sistema pone nombre e icono. */
export interface MomentoCatalogo {
  id: string;
  nombre: string;
  icon: string;
}
export const ITINERARIO_CATALOGO: MomentoCatalogo[] = [
  { id: 'ceremonia', nombre: 'Ceremonia', icon: 'church' },
  { id: 'coctel', nombre: 'Cóctel de bienvenida', icon: 'glass-water' },
  { id: 'cena', nombre: 'Cena', icon: 'utensils' },
  { id: 'primer-baile', nombre: 'Primer baile', icon: 'music' },
  { id: 'fiesta', nombre: 'Baile y fiesta', icon: 'music' },
  { id: 'brindis', nombre: 'Brindis', icon: 'glass-water' },
  { id: 'ramo', nombre: 'Lanzamiento del ramo', icon: 'sparkles' },
  { id: 'despedida', nombre: 'Despedida', icon: 'sparkles' },
];

/** Catálogo de vestimenta (🏛): la pareja elige el código; el sistema pone el copy. */
export interface VestimentaCatalogo {
  codigo: string;
  nombre: string;
  copy: string;
}
export const VESTIMENTA_CATALOGO: VestimentaCatalogo[] = [
  { codigo: 'etiqueta-rigurosa', nombre: 'Etiqueta rigurosa', copy: 'Frac o smoking; vestido largo de gala.' },
  { codigo: 'etiqueta-formal', nombre: 'Etiqueta formal', copy: 'Smoking o traje oscuro; vestido largo.' },
  { codigo: 'formal', nombre: 'Formal', copy: 'Te pedimos vestir de gala para acompañarnos en esta celebración.' },
  { codigo: 'coctel', nombre: 'Cóctel', copy: 'Traje; vestido de cóctel a la rodilla o midi.' },
  { codigo: 'semiformal', nombre: 'Semiformal', copy: 'Traje sin corbata opcional; vestido elegante.' },
  { codigo: 'campestre-elegante', nombre: 'Campestre elegante', copy: 'Elegancia relajada para un entorno al aire libre.' },
  { codigo: 'playa-formal', nombre: 'Playa formal', copy: 'Lino y tonos claros; calzado apto para arena.' },
];

/** Títulos de las tarjetas de regalos (🏛). */
export const REGALO_TARJETAS = {
  mesaRegalos: 'Mesa de regalos',
  transferencia: 'Transferencia',
  transferenciaQR: 'Transferencia QR',
  efectivoSobre: 'Lluvia de sobres',
} as const;

/** Helpers de lookup. */
export function momento(id: string): MomentoCatalogo | undefined {
  return ITINERARIO_CATALOGO.find((m) => m.id === id);
}
export function vestimenta(codigo: string): VestimentaCatalogo | undefined {
  return VESTIMENTA_CATALOGO.find((v) => v.codigo === codigo);
}
